module.exports = __webpack_public_path__ + "img/jesus-crown-etching-thumb.jpg";